// extracted by mini-css-extract-plugin
export default {"wrap":"vocabularyActivity_wrap__u8QAW","vocabTable":"vocabularyActivity_vocabTable__2zBE5","content":"vocabularyActivity_content__2tyvP"};